<template>
        <form>
            <div class="vx-col mb-2 w-full">
                <div class="vx-row mb-6">
                    <div class="vx-col w-full mb-2">
                        <div class="m-2"><span class="text-danger">* </span><span>Qual é a necessidade do cliente?</span></div>
                        <div class="flex justify-center md:justify-start lg:justify-start flex-wrap w-full">
                            <div class="p-2 flex w-full lg:w-64 lg:w-1/4 md:w-1/2 box-height" v-for="(need, index) in customerNeed" :key="index">
                                <input-box name="necessidade do cliente" class="w-full h-full cursor-pointer" v-validate="'required'" :vs-value="need.text" type="checkbox" v-model="form.customer_need">
                                    <span slot="title">{{need.text}}</span>
                                </input-box>
                            </div>
                        </div>
                        <span class="text-danger text-sm"  v-show="errors.has('necessidade do cliente')">{{ errors.first('necessidade do cliente') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <div class="m-2"><span class="text-danger">* </span><span>Qual é o tamanho da sua empresa?</span></div>
                        <div class="flex justify-center md:justify-start lg:justify-start flex-wrap w-full">
                            <div class="p-2 flex w-full lg:w-64 lg:w-1/4 md:w-1/2 box-height" v-for="(range, index) in employeesRange" :key="index">
                                <input-box type="radio" name="tamanho empresa" v-validate="'required'" :vs-value="range.label" v-model="form.company_size" class="w-full h-full cursor-pointer">
                                    <span slot="title">{{range.label}}</span>
                                    <div class="mt-2" slot="description">
                                        <span>{{range.text}}</span>
                                    </div>
                                </input-box>
                            </div>
                        </div>
                        <span class="text-danger text-sm"  v-show="errors.has('tamanho empresa')">{{ errors.first('tamanho empresa') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <div class="m-2"><span class="text-danger">* </span><span>Qual o Faturamento da sua empresa?</span></div>
                        <div class="flex justify-center lg:justify-between flex-wrap w-full lg:flex-shrink-0">
                            <div class="p-2 flex w-full lg:w-64 lg:w-1/4 md:w-1/2 box-height" v-for="(profit, index) in companyProfit" :key="index">
                                <input-box type="radio" name="faturamento da empresa" class="w-full h-full cursor-pointer" v-validate="'required'" :vs-value="profit.text" v-model="form.company_profit">
                                    <span slot="title">{{profit.text}}</span>
                                </input-box>
                            </div>
                        </div>
                        <span class="text-danger text-sm"  v-show="errors.has('faturamento da empresa')">{{ errors.first('faturamento da empresa') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <div class="m-2"><span class="text-danger">* </span><span>Qual é o Segmento da empresa?</span></div>
                        <div class="flex justify-center lg:justify-between flex-wrap w-full lg:flex-shrink-0">
                            <vs-select
                                class="w-full select"
                                v-model="form.business_type"
                                name="segmento da empresa" v-validate="'required'"
                                autocomplete
                                placeholder="Digite o segmento da empresa"
                            >
                                <vs-select-item v-for="bus in business" :key="bus.nome" :text="bus.nome" :value="bus.nome"></vs-select-item>
                            </vs-select>
                        </div>
                        <span class="text-danger text-sm"  v-show="errors.has('segmento da empresa')">{{ errors.first('segmento da empresa') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full lg:w-1/2">
                        <div class="m-2"><span class="text-danger">* </span><span>Como nos conheceu?</span></div>
                        <vs-select
                                class="w-full select"
                                v-validate="'required'"
                                autocomplete
                                v-model="form.met_us.type"
                                name="como nos conheceu"
                                @change="clearIndication"
                                no-data="Nenhum registro encontrado">
                            <vs-select-item v-for="(option, key) in metUsOptions" :key="key" :text="option.name" :value="option.name"></vs-select-item>
                        </vs-select>
                        <span class="text-danger text-sm"  v-show="errors.has('como nos conheceu')">{{ errors.first('como nos conheceu') }}</span>
                    </div>
                    <div class="vx-col w-full lg:w-1/2">
                        <div class="m-2"><span>Irá fazer importação de algum sistema?</span></div>
                        <vs-switch class="w-16 mt-6" v-model="form.import_system.yes">
                            <span slot="on">Sim</span>
                            <span slot="off">Não</span>
                        </vs-switch>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full lg:w-1/2">
                        <div v-show="showIndicationField">
                            <div class="m-2"><span class="text-danger">* </span><span>Quem indicou?</span></div>
                            <vs-select
                                    class="w-full"
                                    autocomplete v-model="form.met_us.customer_id" name="indicação" @input-change="searchClients"
                                    v-validate="showIndicationField ? 'required' : ''"
                                    v-if="showIndicationField"
                                    no-data="Nenhum registro encontrado">
                                <vs-select-item :key="index" v-for="(user, index) in users" :text="user.company.fantasy_name" :value="user.company.id_company"></vs-select-item>
                            </vs-select>
                            <span class="text-danger text-sm"  v-show="errors.has('indicação')">{{ errors.first('indicação') }}</span>
                        </div>
                    </div>
                    <div class="vx-col w-full lg:w-1/2" v-show="form.import_system.yes">
                        <div class="m-2"><span>Qual tipo do sistema de importação?</span></div>
                        <div class="vs-row mt-4">
                            <vs-radio class="mr-6" v-model="form.import_system.type" :vs-value="import_system.name" v-for="(import_system, index) in getImportSystemTypes()" :key="index">{{import_system.name}}</vs-radio>
                        </div>
                    </div>
                </div>
            </div>
    </form>
</template>

<script>
import InputBox from "../../components/inputBox/inputBox";
export default {
    components: {
        InputBox
    },
    props: {
        system: Object
    },

    data () {
        return {
            form: {
                company_profit: null,
                business_type: null,
                company_size: null,
                import_system: {},
                met_us: {},
                customer_need: []
            },
            apps: [],
            users: [],
            business: [],
            employeesRange: [],
            companyProfit: [],
            customerNeed: [],
            metUsOptions: [
                {name: 'Midia Digital (Redes Sociais e/ou Google)'},
                {name: 'Indicação de Contador/Outros Parceiros'},
                {name: 'Indicação de Clientes'},
                {name: 'Venda Direta do Time Bitis ou Representação'},
            ]
        }
    },

    computed: {
        showIndicationField () {
            return ['Indicação de Clientes', 'Indicação de Contador/Outros Parceiros'].includes(this.form.met_us.type)
        }
    },

    methods: {
        clearIndication () {
            this.form.met_us.customer_id  = null;
        },

        async getUserIndicationById(customerId)
        {
            const {data} = await this.$axios.get(`company/${customerId}`);
            this.users = [data.data];
        },

        async getBusiness () {
            const {data} = await this.$axios.get("consulta/business");
            this.business = data;
        },

        async getEmployeesRange () {
            const {data} = await this.$axios.get("consulta/companySize");
            this.employeesRange = data.map(range => ({label: range.nome, text: range.descricao, id: range.id_tamanho_empresa}));
        },

        async getCompabyProfitRange () {
            const {data} = await this.$axios.get("consulta/companyProfit");
            this.companyProfit = data.map(size => ({text: size.descricao, id: size.id_faturamento_empresa}));
        },

        async getCustomerNeed()
        {
            const {data} = await this.$axios.get("consulta/customerNeed");
            this.customerNeed = data.map(need => ({text:need.nome, id: need.id_necessidade_empresa}));
        },

        getImportSystemTypes () {
            return [
                {name: 'Web', id:1},
                {name:'Aplicativo', id:1},
            ]
        },

        async validateForm () {
            return await this.$validator.validateAll().then(result => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },

        getForm () {
            return this.form;
        }
    },

    updated () {
        if (this.companyProfit.length > 0 && this.employeesRange.length > 0 && this.business.length > 0) {
            this.$emit("loading", false);
        }
    },

    created() {
        this.$emit("loading", true);
        //this.users.push({nome:this.form.met_us.customer_name, id_pessoa: this.form.met_us.customer_id});
        /**
         * Por um problema que o vue tem ao compilar a apliação, resolvi declarar a função de pesquisa do cliente aqui.
         * Se eu declarar em methods não posso usar a sintaxe do debounce
         */
        this.searchClients = _.debounce(async (q) => {
            const name = q.target.value
            if (!name) return;

            this.users = [];
            const {data} = await this.$axios.get(`company/allUsers`, {
                params: {
                    name: name
                }
            });
            if (data.data) {
                this.users = data.data;
            }
        }, 600);

        this.form = this.system || this.form;
        this.getBusiness();
        this.getEmployeesRange();
        this.getCompabyProfitRange();
        this.getCustomerNeed();

        if (this.form.met_us.customer_id) {
            this.getUserIndicationById(this.form.met_us.customer_id);
        }
    },
}
</script>

<style scoped>
    .box-height {
        height: 7rem;
    }
</style>
